import request from '@/axios';
import website from "@/website";
import {Encrypt} from "@/util/crypto";

export default class Record {

  constructor(table) {
    this.table = table;
    this.condition = [];
    this.entityValue = {};
    this.limitValue = 10;
    this.skipValue = 0;
    this.orderValue = "";
    this.selectValue = "*";
    this.sumField = "";
    this.countField = "";
    this.tokenValue = "";
    this.authValue = false;
    this.usernameValue = "";
  }

  auth(value) {
    this.authValue = value;
  }

  token(value) {
    this.tokenValue = value;
  }

  username(value) {
    this.usernameValue = value;
  }

  select(value) {
    this.selectValue = value;
  }

  equalTo(field, require, value) {
    this.condition.push(field + require + value);
  }

  sumTo(field) {
    this.sumField = field;
  }

  countTo(field) {
    this.countField = field;
  }

  entity(value) {
    this.entityValue = value;
  }

  limit(value) {
    this.limitValue = value;
  }

  skip(value) {
    this.skipValue = value;
  }

  order(value) {
    this.orderValue = value;
  }

  find() {
    return request({
      url: website.ORDER.url + '/find',
      method: 'get',
      params: {
        auth: Encrypt(this.authValue),
        token: this.tokenValue,
        username: Encrypt(this.usernameValue),
        table: Encrypt(this.table),
        select: Encrypt(this.selectValue),
        condition: Encrypt(this.condition.join(",")),
        limit: Encrypt(this.limitValue),
        skip: Encrypt(this.skipValue),
        order: Encrypt(this.orderValue),
        sum: Encrypt(this.sumField),
        count: Encrypt(this.countField),
      }
    })
  }

  count() {
    return request({
      url: website.ORDER.url + '/count',
      method: 'get',
      params: {
        auth: Encrypt(this.authValue),
        token: this.tokenValue,
        username: Encrypt(this.usernameValue),
        table: Encrypt(this.table),
        condition: Encrypt(this.condition.join(",")),
        limit: Encrypt(this.limitValue),
        skip: Encrypt(this.skipValue),
        order: Encrypt(this.orderValue),
      }
    })
  }

  save() {
    return request({
      url: website.ORDER.url + '/save',
      method: 'post',
      params: {
        auth: Encrypt(this.authValue),
        token: this.tokenValue,
        username: Encrypt(this.usernameValue),
        table: Encrypt(this.table),
        entity: Encrypt(JSON.stringify(this.entityValue))
      }
    })
  }

  update() {
    return request({
      url: website.ORDER.url + '/update',
      method: 'post',
      params: {
        auth: Encrypt(this.authValue),
        token: this.tokenValue,
        username: Encrypt(this.usernameValue),
        table: Encrypt(this.table),
        entity: Encrypt(JSON.stringify(this.entityValue))
      }
    })
  }

  remove(ids) {
    return request({
      url: website.ORDER.url + '/remove',
      method: 'post',
      params: {
        auth: Encrypt(this.authValue),
        token: this.tokenValue,
        username: Encrypt(this.usernameValue),
        table: Encrypt(this.table),
        ids: Encrypt(ids)
      }
    })
  }

}
